import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Zoom from "@mui/material/Zoom";
import { SxProps } from "@mui/system";
// import Button from "@mui/material/Button";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Link from "@mui/material/Link";

const boxSx: SxProps = {
  // backgroundColor: theme.palette.primary.main と同義
  bgcolor: "#f4f0e5",
  color: "#302000",
  height: 80,
};

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: React.ReactElement;
}

function ScrollTop(props: Props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = ((event.target as HTMLDivElement).ownerDocument || document).querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box onClick={handleClick} role="presentation" sx={{ position: "fixed", bottom: 16, right: 16 }}>
        {children}
      </Box>
    </Zoom>
  );
}

export default function BackToTop() {
  return (
    <React.Fragment>
      <CssBaseline />
      {/* 高さ調整 */}
      <AppBar position="static">
        <Toolbar sx={boxSx} id="back-to-top-anchor">
          <div>
            <Link color="inherit" href="https://www.h-ix.jp/">
              <img src="./hixlogo.png" alt="h-ix logo" />
            </Link>
          </div>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}></Typography>
          {/* <Button color="inherit">
            <MailOutlineIcon />
            お問い合わせ
          </Button> */}
        </Toolbar>
      </AppBar>
      <ScrollTop>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </React.Fragment>
  );
}
